var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite-icon",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.SetFavoriteRouteName(_vm.$route.name)}}},[_c('i',{staticClass:"font-18 fa-star",class:{
			fal: _vm.favoriteRouteName !== _vm.$route.name,
			fas: _vm.favoriteRouteName === _vm.$route.name,
		}})])
}
var staticRenderFns = []

export { render, staticRenderFns }